import Layout from '@/page/index'

const pipe = x => () => import( /* webpackChunkName: "page" */ `@/page/${x}`)
const vpipe = v => () => import( /* webpackChunkName: "page" */ `@/views/${v}`)
export default [
  { path: '/login', name: '登录页', component: pipe('login/index'), meta: { keepAlive: true, isTab: false, isAuth: false } },
  { path: '/', name: '主页', redirect: '/wel' },
  { path: '/lock', name: '锁屏页', component: pipe('lock/index'), meta: { keepAlive: true, isTab: false, isAuth: false } },
  {
    path: '/myiframe',
    component: Layout,
    redirect: '/myiframe',
    children: [
      { path: ":routerPath", name: 'iframe', component: pipe('iframe/main'), props: true }
    ]
  },
  {path: '/summary', name: '广告结算', component: vpipe('projectSettlement/summary'), meta: { keepAlive: true, isTab: false, isAuth: false }},
  {path: '/procedure', name: '结算过程', component: vpipe('projectSettlement/procedure'), meta: { keepAlive: true, isTab: false, isAuth: false }},
  { path: '/bigData/userGraph/detail/isAuth', name: '用户图谱事件分析', component: vpipe('bigData/userGraph/detail'), meta: { isTab: false, isAuth: false }},
  { path: '/feishu-fail', name: '拒绝授权', component: pipe('login/index'), meta: { keepAlive: true, isTab: false, isAuth: false } },
  { path: '/feishu-success', name: '同意授权', component: pipe('login/index'), meta: { keepAlive: true, isTab: false, isAuth: false } },
  { path: '/404', name: '404', component: pipe('error-page/404'), meta: { keepAlive: true, isTab: false, isAuth: false } },
  { path: '/403', name: '403', component: pipe('error-page/403'), meta: { keepAlive: true, isTab: false, isAuth: false } },
  { path: '/500', name: '500', component: pipe('error-page/500'), meta: { keepAlive: true, isTab: false, isAuth: false } },
  { path: '*', redirect: '/404' }
]
